/* 販売店一覧リスト */
import React, { useState, memo } from 'react';
import { Grid, _ } from 'gridjs-react';
import { store_list_index, project_list_staff_read_index as read_index } from '../Const';
var StoreList = function (_a) {
    var stores = _a.stores, handleRowChange = _a.handleRowChange, handleClickStoreAnchor = _a.handleClickStoreAnchor;
    var rows = useState(10)[0];
    return (React.createElement(Grid, { data: stores, columns: [
            {
                id: 'myCheckbox',
                name: '',
                formatter: function (cell, row) {
                    return _(React.createElement("input", { className: "row-selection", type: "checkbox", value: "" + row.cells[read_index.reception_cd].data, key: "" + row.cells[read_index.reception_cd].data, onChange: function () { return handleRowChange(String(row.cells[read_index.reception_cd].data)); } }));
                },
                width: '10px',
            },
            {
                id: 'store',
                name: '販売店',
                width: '60px',
                formatter: function (cell, row) {
                    return _(React.createElement("a", { className: "link-text", href: "" + location.origin + process.env.MIX_MOCK_URL + "/staff/store/edit/" + row.cells[store_list_index.store_number].data, onClick: handleClickStoreAnchor }, "" + row.cells[store_list_index.store_number].data));
                },
            },
            {
                id: 'gsb',
                name: 'GSB',
                width: '30px',
            },
            {
                id: 'gss',
                name: 'GSS',
                width: '30px',
            },
            {
                id: 'gsms',
                name: 'GSMS',
                width: '30px',
            },
            {
                id: 'gs',
                name: 'GS',
                width: '30px',
            },
            {
                id: 'crsa',
                name: 'CRSA',
                width: '30px',
            },
            {
                id: 'crsb',
                name: 'CRSB',
                width: '30px',
            },
            {
                id: 'gs9',
                name: 'GS9',
                width: '30px',
            },
            {
                id: 'kanji_mame',
                name: '漢字名称',
                width: '160px',
                formatter: function (cell, row) {
                    return _(React.createElement("a", { className: "link-text", href: "" + location.origin + process.env.MIX_MOCK_URL + "/staff/store/edit/" + row.cells[store_list_index.store_number].data, onClick: handleClickStoreAnchor }, row.cells[store_list_index.store_name].data));
                },
            },
            {
                id: 'phone',
                name: '電話番号',
                width: '140px',
            },
            {
                id: 'post_code',
                name: '郵便番号',
                width: '100px',
            },
            {
                id: 'adress',
                name: '住所',
                width: '200px',
            },
            {
                id: 'update_at',
                name: '更新日',
                width: '100px',
            },
            {
                id: 'update_user',
                name: '更新者',
                width: '100px',
            },
        ], search: false, sort: false, pagination: {
            enabled: true,
            limit: rows,
        }, fixedHeader: true, height: "600px" }));
};
export default memo(StoreList);
